<!-- Empty install base or Landing error -->
<my-bill-odb-page-base-structure
  [hasCustomHeader]="true"
  [hasTopContent]="true"
  *ngIf="(hasEmptyInstallbase$ | async) || hasBalanceFetchingError || isUr"
>
  <my-bill-overview-header
    customHeader
    [mainTitle]="mainTitle"
    [shouldDisplayBackButton]="false"
  ></my-bill-overview-header>
  <div class="panel rs-no-padding" topContent>
    <ng-container [ngTemplateOutlet]="messageBox"></ng-container>
  </div>
</my-bill-odb-page-base-structure>

<!-- Landing content -->
<my-bill-odb-page-base-structure
  [hasCustomHeader]="true"
  [leftColumnClassWidth]="'medium-8'"
  [rightColumnClassWidth]="'medium-4'"
  *ngIf="
    !isLandingLoadingSkeletonDisplayed &&
    !hasBalanceFetchingError &&
    (hasEmptyInstallbase$ | async) === false &&
    !isUr
  "
>
  <ng-container customHeader>
    <my-bill-overview-header
      [mainTitle]="mainTitle"
      [shouldDisplayBackButton]="isAccountSelectedWithMoreThanOneAccount"
    ></my-bill-overview-header>
    <my-bill-evolution-tab
      [isEvolutionTabActive]="false"
      *ngIf="isEvolutionScreenReady"
    ></my-bill-evolution-tab>
  </ng-container>

  <div
    class="rs-panel-big rs-bg-c2 clearfix"
    leftColumnContent
    data-cy="landingContentMultiplePAs"
  >
    <p class="rs-tit3">
      {{ 'bills.redesign.overview.selectAddress' | translate }}
    </p>
    <my-bill-account-card
      *ngFor="let billingAccount of billingAccounts"
      [billingAccount]="billingAccount"
      [billingAccounts]="billingAccounts"
      (click)="onAccountCardClick(billingAccount)"
    >
    </my-bill-account-card>
  </div>
  <div class="rs-panel-big rs-bg-c2 clearfix" rightColumnContent>
    <my-bill-faq-settings-container
      [billingDocument]="billingDocument"
      [billingAccount]="billingAccount"
      [customerAccount]="customerAccount"
      [zone]="'mybill.landing'"
      [isResUser]="isResUser"
    ></my-bill-faq-settings-container>
  </div>
</my-bill-odb-page-base-structure>

<!-- Landing loading skeleton -->
<my-bill-odb-page-base-structure
  [hasTopContent]="true"
  *ngIf="isLandingLoadingSkeletonDisplayed && !isUr"
>
  <my-bill-landing-skeleton topContent> </my-bill-landing-skeleton>
</my-bill-odb-page-base-structure>

<ng-template #messageBox>
  <lib-generic-message-box
    [messageType]="messageBoxType"
    id="messageBoxType"
    [showCross]="paymentMade !== undefined"
  >
    <ng-container Title *ngIf="messageBoxTitleKey">{{
      messageBoxTitleKey | translate
    }}</ng-container>
    <span
      Content
      [innerHtml]="messageBoxContent"
      *ngIf="messageBoxContent"
    ></span>
    <p Content *ngIf="messageBoxContentKey">
      {{ messageBoxContentKey | translate }}
    </p>
  </lib-generic-message-box>
</ng-template>
